<template>
    <v-layout column fill-height>
        <!-- <breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Colaboradores (Cadastro Único)" descricao="Gerencie seus colaboradores e defina as permissões de acesso." :tabs="tabOptions" /> -->
        <breadcrumbs titulo="Colaboradores" descricao="Gerencie seus colaboradores e defina as permissões de acesso."/>
        <v-layout class="main">
            <v-flex v-if="tab == 1">
                <v-layout row class="content-header">
                    <v-flex md9 class="content-title">
                        <h2>Membros</h2>
                        <h4>Detalhes do colaborador.</h4>
                    </v-flex>
                    <v-flex md-3 class="text-right">
                        <v-btn color="success" @click="listarColaboradores"><v-icon>mdi-view-list</v-icon>&nbsp; Listar colaboradores</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row class="content-body overflow-y-auto">
                    <v-flex md12>
                        <MembroDetalhes :membro="membro" />
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex v-if="tab == 2">
                <v-layout row class="content-header">
                    <v-flex md9 class="content-title">
                        <h2>Membros</h2>
                        <h4>Gerencie os grupos de acesso e as autorizações de cada um.</h4>
                    </v-flex>
                    <v-flex md-3 class="text-right">
                        <v-btn color="info"><v-icon>add</v-icon>&nbsp; Novo Grupo</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row class="content-body overflow-y-auto">
                    <v-flex md12>
                        <GrupoDetalhes />
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>

    </v-layout>
</template>

<script>

import Router from "@/router";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import MembroDetalhes from "@/components/portal/colaboradoresCadastroUnico/MembroDetalhes";
import GrupoDetalhes from "@/components/portal/colaboradoresCadastroUnico/GrupoDetalhes";
import Helpers from "@/utilities/Helpers";

export default {
    mixins: [Helpers],    
  components: {
    breadcrumbs,
    MembroDetalhes,
    GrupoDetalhes
  },
  props: ["id"],
  data() {
    return {
        membro: {
            id: 0,
            name: "",
            type: "F",
            register: "",
            birth: null,
            sex: "",
            address: null,
            number: null,
            complement: null,
            location: null,
            zipCode: null,
            city: null,
            uf: null,
            email:null,
            phoneContact: null
        },
        tab: 1,
        guia: "Colaboradores Novo > Membros",
        tabOptions: [
            { id: 1, titulo: "Membros"},
            { id: 2, titulo: "Grupos"},
        ]
    }
  },
  methods: {
    changeTab(value){
        this.tab = value;
        this.guia = "Colaboradores Novo > " + this.tabOptions[value - 1].titulo;
    },
    listarColaboradores(){
        Router.push("/colaboradores-cadastro-unico");
    }
 },
 mounted(){
    // Request colaborador
    if (this.id !== undefined)
    {
        Vue.prototype.$httpIdentityServerApi.get(
            `UserRole/user-role-person/${this.id}`,
            {
            headers: {
                "content-type": "application/json"
            }
            }
        ).then(res => {
            console.log("getRole retorno >");
            console.log(res.data);
            this.membro = res.data;
            //this.membro.claimType = this.membro.roleClaims[0].claimType;
            this.membro.dataNasc = this.FormatarData(this.membro.birth);
            //console.log(this.membro);
            this.loading = false;
            this.fullLoading = false;
        })
        .catch(ex => {
            console.log(ex);
            this.loading = false;
            this.fullLoading = false;
        });
    }
 }
};
</script>